module.exports = __webpack_public_path__ + "img/IMG_7068.a6b2d159.webp";